var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import ReactDOM from "react-dom/client";
import Widget from "./widget";
import "./styles/tailwind.css";
import "./styles/theme.css";
import configService from "./services/configService";
/**
 * Detect the base URL of the widget script so we can fetch widget.css
 * relative to wherever the bundle was loaded from.
 */
function detectBaseUrl() {
    // Check all <script> tags for our bundle
    var scripts = document.querySelectorAll('script[src]');
    for (var _i = 0, _a = Array.from(scripts); _i < _a.length; _i++) {
        var script = _a[_i];
        var src = script.getAttribute('src') || '';
        if (src.includes('widget.bundle.js')) {
            return src.replace(/widget\.bundle\.js.*$/, '');
        }
    }
    // Fallback to current origin
    return window.location.origin + '/';
}
/**
 * Inject CSS into the shadow root so styles work inside the isolation boundary.
 *
 * Strategy:
 *  1. Try fetching the extracted widget.css from the same base as the JS bundle.
 *  2. If that fails (e.g. dev-mode where style-loader inlines everything into
 *     <head>), clone every <style> tag from the document into the shadow root.
 */
function injectStyles(shadowRoot) {
    return __awaiter(this, void 0, void 0, function () {
        var base, res, css, tag, _a, headStyles, links;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, , 5]);
                    base = detectBaseUrl();
                    return [4 /*yield*/, fetch("".concat(base, "widget.css"))];
                case 1:
                    res = _b.sent();
                    if (!res.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, res.text()];
                case 2:
                    css = _b.sent();
                    tag = document.createElement('style');
                    tag.textContent = css;
                    shadowRoot.appendChild(tag);
                    return [2 /*return*/];
                case 3: return [3 /*break*/, 5];
                case 4:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 5:
                    headStyles = document.querySelectorAll('style');
                    headStyles.forEach(function (s) {
                        var clone = document.createElement('style');
                        clone.textContent = s.textContent || '';
                        shadowRoot.appendChild(clone);
                    });
                    links = document.querySelectorAll('link[rel="stylesheet"]');
                    links.forEach(function (link) {
                        var href = link.getAttribute('href') || '';
                        // Only clone stylesheets from our own origin / dev server
                        if (href.startsWith('/') || href.includes('localhost') || href.includes('widget')) {
                            var clonedLink = link.cloneNode(true);
                            shadowRoot.appendChild(clonedLink);
                        }
                    });
                    return [2 /*return*/];
            }
        });
    });
}
function renderWidget(containerId, config) {
    return __awaiter(this, void 0, void 0, function () {
        var error_1, defaultContainerId, targetId, container, shadowRoot, mountPoint;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, configService.initialize(true)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error('Failed to initialize widget config:', error_1);
                    return [3 /*break*/, 3];
                case 3:
                    defaultContainerId = 'quicksmart-widget-container';
                    targetId = containerId || defaultContainerId;
                    container = document.getElementById(targetId);
                    // If container doesn't exist, create it
                    if (!container) {
                        container = document.createElement('div');
                        container.id = targetId;
                        document.body.appendChild(container);
                    }
                    if (!container.shadowRoot) {
                        shadowRoot = container.attachShadow({ mode: 'open' });
                    }
                    else {
                        shadowRoot = container.shadowRoot;
                    }
                    mountPoint = shadowRoot.getElementById('widget-root');
                    if (!mountPoint) {
                        mountPoint = document.createElement('div');
                        mountPoint.id = 'widget-root';
                        shadowRoot.appendChild(mountPoint);
                    }
                    // Inject CSS into shadow root BEFORE rendering
                    return [4 /*yield*/, injectStyles(shadowRoot)];
                case 4:
                    // Inject CSS into shadow root BEFORE rendering
                    _a.sent();
                    // Render the widget
                    ReactDOM.createRoot(mountPoint).render(React.createElement(Widget, { config: config }));
                    return [2 /*return*/];
            }
        });
    });
}
window.renderWidget = renderWidget;
